import { Routes, Route } from "react-router-dom";
import NavBar from './Components/Navigation/NavBar';
import Footer from './Components/Footer/Footer';
import Home from "./Views/Home/Home";
import ServiceAreas from "./Views/ServiceAreas/ServiceAreas";
import Contact from "./Views/Contact/Contact";
import Error from './Components/Error/Error';
import ScrollToTop from "./Components/ScrollToTop";
import Pricing from "./Views/Pricing/Pricing";
import React, { useEffect, useState } from "react";
import Loader from "./Components/Loader";

function App() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoaded(true), 300);
        return () => clearTimeout(timer);
    }, []);

    if (!isLoaded) return <Loader />;

    return (
        <main style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <div className="root" style={{ flex: 1 }}>
                <NavBar />
                <ScrollToTop />
                <Routes>
                    <Route path="/athol" element={<ServiceAreas />} />
                    <Route path="/blanchard" element={<ServiceAreas />} />
                    <Route path="/coeur-d-alene" element={<ServiceAreas />} />
                    <Route path="/post-falls" element={<ServiceAreas />} />
                    <Route path="/priest-river" element={<ServiceAreas />} />
                    <Route path="/rathdrum" element={<ServiceAreas />} />
                    <Route path="/sandpoint" element={<ServiceAreas />} />
                    <Route path="/spirit-lake" element={<ServiceAreas />} />
                    <Route path="/deer-park" element={<ServiceAreas />} />
                    <Route path="/newport" element={<ServiceAreas />} />
                    <Route path="/spokane" element={<ServiceAreas />} />
                    <Route path="/benewah-county" element={<ServiceAreas />} />
                    <Route path="/bonner-county" element={<ServiceAreas />} />
                    <Route path="/kootenai-county" element={<ServiceAreas />} />
                    <Route path="/pend-oreille-county" element={<ServiceAreas />} />
                    <Route path="/spokane-county" element={<ServiceAreas />} />

                    <Route path="/boundary-county" element={<ServiceAreas />} />
                    <Route path="/stevens-county" element={<ServiceAreas />} />

                    <Route path="/hayden" element={<ServiceAreas />} />
                    <Route path="/sagle" element={<ServiceAreas />} />
                    <Route path="/careywood" element={<ServiceAreas />} />
                    <Route path="/oldtown" element={<ServiceAreas />} />
                    <Route path="/priest-lake" element={<ServiceAreas />} />

                    <Route path="/colbert" element={<ServiceAreas />} />
                    <Route path="/mead" element={<ServiceAreas />} />

                    <Route path="/service-areas" element={<ServiceAreas />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/" element={<Home />} />

                    {/* Catch-all route for bad paths */}
                    <Route path="*" element={<Error />} />
                </Routes>
            </div>
            <Footer />
        </main>
    );
}

export default App;
